var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-white px-3 rounded-tl-3xl rounded-tr-3xl pt-3"},[_c('TabIndicator',{attrs:{"index":"3"}}),_c('keep-alive',[_c(_vm.module,{tag:"components"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }